import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function VentasGeneral({ title }) {

    registerLocale("es", es);

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();

    const [date1, setDate1] = useState(new Date(year, month, 1));
    const [date2, setDate2] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1, date2]);

    const [value, onChange] = useState([new Date(year, month, 1), new Date()]);
    const [titleExcel, setTitleExcel] = useState(
        (value)
            ? "Reporte General de Ventas - " + (value[0] != null ? Utilities.formaterDate(value[0]) : "") + " / " + (value[1] != null ? Utilities.formaterDate(value[1]) : "")
            : "Reporte General de Ventas - " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "")
    )

    const header = [
        {
            headerName: 'Sociedad',
            field: 'soc',
            type: 'rightAligned',
        },
        {
            headerName: 'Mall',
            field: 'unidadEconomica'
        },
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Contrato antiguo',
            field: 'contAnterior',
        },
        {
            headerName: 'Denominación Contrato',
            field: 'denCont',
        },
        {
            headerName: 'Moneda',
            field: 'moneda',
        },
        {
            headerName: 'CeBe',
            field: 'centBen',
        },
        {
            headerName: 'Denom CeBe',
            field: 'denCBen',
        },
        {
            headerName: 'Tipo Vta',
            field: 'tVenta',
        },
        {
            headerName: 'Denom Tipo Vta',
            field: 'denTVenta',
        }
    ]

    let dateFormatedInicio = null;
    let dateFormatedFinal = null;

    if (dateRange[0] != null && dateRange[1] != null) {
        dateFormatedInicio = ("0" + dateRange[0].getDate()).slice(-2) + "/" + ("0" + (dateRange[0].getMonth() + 1)).slice(-2) + "/" + dateRange[0].getFullYear();
        dateFormatedFinal = ("0" + dateRange[1].getDate()).slice(-2) + "/" + ("0" + (dateRange[1].getMonth() + 1)).slice(-2) + "/" + dateRange[1].getFullYear();
    }

    // if (dateRange[0] != null && dateRange[1] != null) {
    // if (dateFormatedInicio == dateFormatedFinal) {
    header.push(
        {
            headerName: 'Periodo',
            field: 'periodo',
            type: 'rightAligned',
        },
        {
            headerName: 'Fecha Vta',
            field: 'fecha',
        }
    )
    // }
    // }

    header.push(
        {
            headerName: 'Monto (S/Igv)',
            field: 'sinIGV',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.sinIGV, true)}</>
            )
        },
        {
            headerName: 'Transacciones',
            field: 'cant',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.cant, true)}</>
            )
        }
    )

    // if (dateFormatedInicio != null && dateFormatedFinal != null) {
    // if (dateFormatedInicio == dateFormatedFinal) {
    header.push(
        {
            headerName: 'Fecha Registro',
            field: 'fechaRegistro',
        },
        {
            headerName: 'Hora',
            field: 'horaRegistro',
        },
        {
            headerName: 'Fecha Modificación',
            field: 'fechaHoraModificacion',
        }
    )
    // }
    // }
    header.push(
        {
            headerComponent: () => (<span>Área (m<sup>2</sup>)</span>),
            field: 'm2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2, true)}</>
            )
        }
    )

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GENERAL_VENTAS]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-header border-0 pt-5">
                        <div className="d-flex align-items-center mb-3">
                            <div className='p-2' style={{ minWidth: "230px" }}>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                                <DateRangePicker
                                    onChange={(dateRange) => {
                                        onChange(dateRange)
                                        if (dateRange) {
                                            setDateRange(dateRange);
                                            setTitleExcel("Reporte General de Ventas - " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : ""))
                                        }
                                    }}
                                    value={value}
                                    format="dd/MM/y"
                                    className="form-control form-control-transparent pe-5"
                                    locale="es"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"VentasGeneral" + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "")}
                            apiService={Api.VentasGeneral}
                            setAuxData={null}
                            header={header}
                            titleExcel={titleExcel}
                            conditions={true}
                            args={{ fechaInicio: dateRange[0] && Utilities.formaterDate(dateRange[0]), fechaFin: dateRange[1] && Utilities.formaterDate(dateRange[1]), token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>

            </PermissionsGate>
        </>
    )
}